var render, staticRenderFns
import script from "./analysis-table.vue?vue&type=script&lang=js"
export * from "./analysis-table.vue?vue&type=script&lang=js"
import style0 from "./analysis-table.vue?vue&type=style&index=0&id=1f6f36b7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6f36b7",
  null
  
)

export default component.exports